import { connect } from 'react-redux';
import Header from './Header';
import { showReviewCount } from '../../../../config/ab/selector';
import { getThemeParameters } from '../../../../config/theme';
import isFeePerBookingProvider from '../../utils/isFeePerBookingProvider';

const mapStateToProps = (state, ownProps) => {
    return {
        showCommunityLabel: getThemeParameters(state).profile.showCommunityLabel,
        showReviewCount: showReviewCount(state) && isFeePerBookingProvider(ownProps.provider),
    };
};

export default connect(mapStateToProps)(Header);
